import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import type { ResponseText } from "../../../ManageQuestions/types";

type Props = {
  response: ResponseText;
  disabled?: boolean;
  value?: string;
  onCommit: (text: string) => void;
  reveal?: boolean;
};

const TextWidget: React.FC<Props> = ({ response, disabled, value = "", onCommit, reveal }) => {
  const [txt, setTxt] = useState(value || "");
  useEffect(() => setTxt(value || ""), [value]);

  return (
    <div className="tap-inputrow">
      <input
        className="tap-input"
        type="text"
        value={txt}
        onChange={(e) => setTxt(e.target.value)}
        onBlur={() => onCommit(txt)}
        disabled={disabled}
        placeholder={response.input_rules?.placeholder || "Your answer"}
        maxLength={response.input_rules?.max_chars || undefined}
      />
      <Button size="sm" variant="primary" onClick={() => onCommit(txt)} disabled={disabled}>Save</Button>
      {reveal && response.evaluation?.strategy === "exact_text" && (
        <div className="tap-reveal-hint">Expected: <b>{response.evaluation?.text || ""}</b></div>
      )}
    </div>
  );
};

export default TextWidget;
